"use client"
import BlockWrapper from "@/ui/common/BlockWrapper"
import styled from "@emotion/styled"
import { mediaQueries, sizes } from "ui"

export const StyledBlockWrapper = styled(BlockWrapper)`
  ${mediaQueries.desktopM} {
    padding: 60px 30px;
  }
`

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  ${mediaQueries.tabletDown} {
    gap: ${sizes.baseSix};
  }
  ${mediaQueries.desktopM} {
    align-items: stretch;
    flex-direction: row;
    gap: ${sizes.baseSix};
    margin-bottom: 20px;
    > * {
      border-inline-end: 1px solid #cccccc;
      padding-inline-end: ${sizes.baseSix};
      width: 100%;
      gap: inherit;
      :last-child {
        border-inline-end: none;
        padding-inline-end: 0;
      }
    }
  }
`
